import React from "react";
import { IconButton, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import styles from "./styles";
import { isEmpty } from "lodash";
import {
  formattedAmount,
  formattedAmountWithoutAed,
} from "../../../../../utils/CommonFunction";
import { useParams } from "react-router-dom";
import { ReactComponent as SmallDhiramIcon } from "../../../../../assets/svg/SmallDhiramIcon.svg";
import { renderCurrencyIcon } from "../../../../../utils/CurrencyUtils";

function BudgetItemModal({ selectedBudget, setSelectedBudget }) {
  const { id } = useParams();

  const handleCloseModal = () => {
    setSelectedBudget(null);
  };

  return (
    <>
      <Dialog
        open={!!selectedBudget}
        onClose={handleCloseModal}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "12px",
          },
        }}
      >
        {selectedBudget && (
          <>
            <DialogTitle
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0",
                position: "relative",
              }}
            >
              <div style={{ position: "relative", width: "100%" }}>
                <img
                  src={
                    !isEmpty(selectedBudget?.buget_image)
                      ? selectedBudget?.buget_image[0]?.image
                      : "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b"
                  }
                  alt="Budget Image"
                  style={{
                    width: "100%",
                    height: "250px",
                    objectFit: "cover",
                    border: "none",
                    borderRadius: "8px",
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                    boxShadow: "none",
                  }}
                />
              </div>
              <IconButton
                onClick={handleCloseModal}
                style={{ position: "absolute", top: 5, right: 5 }}
              >
                <CloseRounded />
              </IconButton>
            </DialogTitle>
            <DialogContent
              style={{
                ...styles.columnFlex,
                ...styles.container,
                gap: "25px",
                padding: "4vh 2vw",
              }}
            >
              <div style={{ ...styles.columnFlex }}>
                <h2 style={styles.modal_heading}>{selectedBudget?.name}</h2>
                <p style={styles.modal_desc}>{selectedBudget?.specification}</p>
              </div>
              <div style={{ ...styles.columnFlex, gap: "15px" }}>
                <div style={styles.section_heading}>Specs</div>
                <div style={{ ...styles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Material Type</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_type || "-"}
                    </p>
                  </div>

                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Material Unit</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_unit || "-"}
                    </p>
                  </div>
                </div>
              </div>{" "}
              <div style={{ ...styles.columnFlex, gap: "15px" }}>
                <div style={styles.section_heading}>Quantity</div>
                <div style={{ ...styles.columnFlex, gap: "15px" }}>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Unit Cost</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.material_unit_price ? (
                        <span
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          {renderCurrencyIcon('small')}
                          {formattedAmountWithoutAed(
                            selectedBudget?.material_unit_price
                          )}
                        </span>
                      ) : (
                        "-"
                      )}
                    </p>
                  </div>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Quantity</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.qty || "-"}
                    </p>
                  </div>



                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Manpower Rate</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.manpower_rate || "-"}
                    </p>
                  </div>
                  <div
                    style={{
                      ...styles.rowFlex,
                      justifyContent: "space-between",
                    }}
                  >
                    <p style={styles.modal_desc}>Days</p>
                    <p style={styles.modal_value}>
                      {selectedBudget?.days || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </DialogContent>
          </>
        )}
      </Dialog>
    </>
  );
}

export default BudgetItemModal;
